// extracted by mini-css-extract-plugin
export default {"MeetingRejectButton":"MeetingRejectButton-module-b4ecce749d22be8cfd87"};